export function makeKERequiredLogic(props) {
    var alternatives = props.alternatives;
    var free = alternatives.free;
    return free;
}
